// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"b17e5fa2","1625":"b17e5fa2","2370":"e62ec21b","5050":"5458bd3e"}[chunkId] + ".chunk.css";
};